import Link from "next/link";
import { useMobileMenu } from "@lib/context/mobile-menu-context";
import { FaChevronRight } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { Logo } from "@components/header";

const collapseItems = [
	{ label: "Startsidan", link: "/" },
	{ label: "Fordon i lager", link: "/fordon" },
	{ label: "Anläggningar", link: "/anlaggningar" },
	{ label: "Sälj ditt fordon", link: "/salj-ditt-fordon" },
	{ label: "Kontakt", link: "/kontakt" },
	{ label: "Om oss", link: "/om-oss" },
];

const MainMenu = () => {
	const { close } = useMobileMenu();

	return (
		<div className="flex flex-col flex-1">
			<div className="flex items-center gap-4 w-full border-b border-white/10 px-4 py-2 text-slate-50">
				<div>
					<button
						className="bg-transparent hover:bg-white/5 p-2 rounded-lg transition-colors cursor-pointer"
						onClick={close}
					>
						<AiOutlineClose size={20} />
					</button>
				</div>
				<div className="py-2">
					<Logo />
				</div>
			</div>

			<div className="space-y-6 flex-1 flex flex-col justify-between p-6">
				<div className="flex flex-col flex-1">
					<ul className="flex flex-col gap-y-2">
						{collapseItems.map((menuItem, index) => {
							return (
								<li
									key={menuItem.link}
									className="text-slate-50 p-4 bg-white/5 hover:bg-linear-to-r hover:from-accent/30 hover:to-transparent border-l-2 border-transparent hover:border-accent transition-all duration-300"
									style={{ animationDelay: `${index * 75}ms` }}
								>
									<Link href={menuItem.link}>
										<button
											className="flex items-center justify-between w-full text-base uppercase font-heading font-semibold"
											onClick={close}
										>
											<span className="sr-only">Till {menuItem.label}</span>
											<span>{menuItem.label}</span>
											<FaChevronRight className="text-gray-500 text-sm" />
										</button>
									</Link>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default MainMenu;
